module.exports = __webpack_public_path__ + "img/1360730785.9f8b4298.jpg";